import { AbstractEntityStore } from '@pf/shared-services';
import { CarrierDto } from '../../entities/carrier.dto';
import { Injectable } from '@angular/core';
import { PFCoreEntities } from '@pf/shared-common';
import {
    persistState,
    sessionStorageStrategy,
} from '@ngneat/elf-persist-state';

@Injectable()
export class CarrierStore extends AbstractEntityStore<CarrierDto> {
    constructor() {
        super(PFCoreEntities.Carrier);

        persistState(this._store, {
            storage: sessionStorageStrategy,
        });
    }
}
